// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.store-btn {
  display: inline-block;
  flex-shrink: 0;
  line-height: 0;
  text-decoration: none;
}

.store-btn img {
  display: block;
  height: 73px;
  width: auto;
}

.store-btn:hover {
  opacity: 0.92;
}

.store-btn:focus-visible {
  outline: 2px solid #fff;
  outline-offset: 3px;
  border-radius: 6px;
}

@media (max-width: 480px) {
  .store-btn {
    width: 100%;
    max-width: 219px;
  }

  .store-btn img {
    width: 100%;
    height: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/StoreButtons/StoreButtons.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".store-btn {\n  display: inline-block;\n  flex-shrink: 0;\n  line-height: 0;\n  text-decoration: none;\n}\n\n.store-btn img {\n  display: block;\n  height: 73px;\n  width: auto;\n}\n\n.store-btn:hover {\n  opacity: 0.92;\n}\n\n.store-btn:focus-visible {\n  outline: 2px solid #fff;\n  outline-offset: 3px;\n  border-radius: 6px;\n}\n\n@media (max-width: 480px) {\n  .store-btn {\n    width: 100%;\n    max-width: 219px;\n  }\n\n  .store-btn img {\n    width: 100%;\n    height: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
